module.exports = __webpack_public_path__ + "media/images/frontend/banner_500x200_3-260b46237d1de491e76d0d3551b3672f.png";